<template>
  <section class="info_wrap" :class="{active: toggleIsVisible}">
    <section class="info_btn" @click="toggle">
      <div>
        <p>
          <span>
            <svg class="icon-info_large">
              <use xlink:href="#icon-Info_large" />
            </svg>
          </span>
          {{txt.common.more_information}}
        </p>
      </div>
      <div>
        <ul>
          <li>
            <h2></h2>
            <p></p>
          </li>
          <li></li>
        </ul>
      </div>
    </section>
    <transition name="fade">
      <section class="info_toggle" v-if="toggleIsVisible">
        <ul>
          <!-- for each -->
          <li v-for="(item, index) in list" :key="index">
            <span v-html="item.title" />
            <p v-html="item.subtitle" />
          </li>
        </ul>
      </section>
    </transition>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    list: Array
  },
  data() {
    return {
      toggleIsVisible: false
    };
  },
  computed: {
    ...mapState({
      txt: state => state.txt
    })
  },
  methods: {
    toggle() {
      this.toggleIsVisible = !this.toggleIsVisible;
    }
  }
};
</script>

<style>
</style>
